/* --------------------------------
[JSファイルの説明]
・gulpで scripts.json の libs の各ファイルを連結し、 /js/libs.js に書き出している
・gulpで scripts.json の scripts の各ファイルを連結＆圧縮し、 /js/scripts.js に書き出している
・HTMLでは上記の libs.js と scripts.js を読み込んでいる
・もしもgulpの環境が無くて更新が困難な場合は、書き出したJSは無視して scripts.json の各ファイルをHTMLで直接読み込んでも動作は可能
-------------------------------- */

//aタグ スムーススクロール
$(function(){
  $('a[href^="#"]').click(function(){
    var speed = 500;
    var href= $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position = target.offset().top;
    $("html, body").animate({scrollTop:position}, speed, "swing");
    return false;
  });
});

$(function(){
  const $menu = $('.p-hd__spMenu a');

  if($menu[0]) {
    const $nav = $('.p-hd__nav');

    $menu.on('click', function(event) {
      $menu.toggleClass('is-on');
      $nav.toggleClass('is-show');
    });
  }
});

$(function(){
  const $agree = $('.js-agreeCheck');

  if($agree[0]) {
    const $dl = $('.js-agreeBtn');

    setTimeout(function(){
      $agree.prop("checked", false);
    }, 10);

    $agree.on('change', function(event) {
      if($(this).prop('checked')) {
        $dl.addClass('is-enabled');
      } else {
        $dl.removeClass('is-enabled');
      }
    });
  }
});

